import {
  AlertTriangle,
  ShowerHead,
  Thermometer,
  Search,
  Toilet,
  ArrowRight,
  Phone,
} from "lucide-react";
import { Link } from "react-router-dom";

const SERVICES = [
  {
    title: "Emergency Plumbing",
    description: "24/7 fast response for any plumbing emergency.",
    icon: AlertTriangle,
    slug: "emergency-plumbing",
  },
  {
    title: "Shower Head Repair",
    description: "Clear blocked drains quickly with professional tools.",
    icon: ShowerHead,
    slug: "shower-head-repair",
  },
  {
    title: "Water Heater Services",
    description: "Install, repair, or maintain water heaters for consistent hot water.",
    icon: Thermometer,
    slug: "water-heater-services",
  },
  {
    title: "Leak Detection & Repair",
    description: "Find hidden leaks and fix them before they cause damage.",
    icon: Search,
    slug: "leak-detection-repair",
  },
  {
    title: "Toilet & Fixture Repair",
    description: "Fix toilets, sinks, and other fixtures for proper function.",
    icon: Toilet,
    slug: "toilet-fixture-repair",
  },
];

export default function ServicesGrid({location}) {
  return (
    <section className="max-w-[90%] xl:max-w-6xl mx-auto space-y-8">

      <div className="space-y-4">
        <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
          All Services
        </div>
        <h2 className="font-black text-gray-900 text-4xl lg:text-5xl tracking-tight leading-tight">
          {location ? `Services We Offer in ${location}` : "Services We Offer"}
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map(({ title, description, icon: Icon, slug }) => (
          <div
            key={slug}
            className="group bg-white border border-gray-100 rounded-2xl p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col gap-5"
          >
            {/* Icon */}
            <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center group-hover:bg-blue-600 transition-colors duration-300">
              <Icon className="w-6 h-6 text-blue-600 group-hover:text-white transition-colors duration-300" />
            </div>

            {/* Text */}
            <div className="flex-1 space-y-1.5">
              <h4 className="font-bold text-gray-900 text-[16px]">{title}</h4>
              <p className="text-gray-500 text-sm leading-relaxed">{description}</p>
            </div>

            {/* Actions */}
            <div className="flex items-center gap-3 pt-1 border-t border-gray-100">
              <Link
                to={`/services/${slug}`}
                className="flex items-center gap-1 text-xs font-bold text-gray-600 hover:text-blue-600 transition-colors"
              >
                Learn More <ArrowRight className="w-3.5 h-3.5" />
              </Link>
              <span className="text-gray-200">|</span>
              <a
                href="tel:(312) 555-0147"
                className="flex items-center gap-1 text-xs font-bold text-blue-600 hover:text-blue-700 transition-colors"
              >
                <Phone className="w-3.5 h-3.5" /> Call Now
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}